import React, { createContext, useContext, useMemo, type ReactElement } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Outlet } from 'react-router-dom';

import type { ITramiteContext } from '@/interfaces/context/ITramite.context.interface';
import type { FormTramiteValues } from '@/interfaces/model/don.interface';

export const defaultValues = {
	documentos: [],
	sujetos: [],
	solicitudesDocumentacion: [],
	estadoTramite: {
		id: 0,
		descripcion: ''
	},
	numeroTramite: '',
	tipoFirmaDesc: '',
	nifEmisor: '',
	nombreNotario: '',
	historial: []
};

const contextDefaultValue: ITramiteContext = {
	getFormValues: () => defaultValues as any,
};

const TramiteContext = createContext<ITramiteContext>(contextDefaultValue);

const TramiteProvider: React.FC = (): ReactElement => {
	const methods = useForm<FormTramiteValues>({ defaultValues, mode: 'onChange' });

	const value: ITramiteContext = useMemo(() => ({ getFormValues: methods.watch }), [methods]);

	return (
		<TramiteContext.Provider value={value}>
			<FormProvider {...methods}>
				<Outlet />
			</FormProvider>
		</TramiteContext.Provider>
	);
};

const useTramiteContext = (): ITramiteContext => {
	const context = useContext(TramiteContext);

	if (context === null) {
		throw new Error('useTramite must be used within provider');
	}

	return context;
};

export { TramiteContext, TramiteProvider, useTramiteContext };
